"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const EmailOutlined_1 = __importDefault(require("@mui/icons-material/EmailOutlined"));
const LocalPhoneOutlined_1 = __importDefault(require("@mui/icons-material/LocalPhoneOutlined"));
const RoomOutlined_1 = __importDefault(require("@mui/icons-material/RoomOutlined"));
const CalendarMonthOutlined_1 = __importDefault(require("@mui/icons-material/CalendarMonthOutlined"));
const LanguageOutlined_1 = __importDefault(require("@mui/icons-material/LanguageOutlined"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const helpers_1 = require("../../../common/helpers/helpers");
const isMobile = () => helpers_1.Helpers.isMobile.Android() || helpers_1.Helpers.isMobile.iOS();
const Wrapper = styled_components_1.default.div `
  display: flex;
  position: relative;
  align-items: center;
  justify-content: flex-start;
  height: 48px;
  padding: 0 16px;
  overflow: hidden;
  cursor: pointer;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }

  &.convention-call-to-action-item {
    flex-direction: column;
    height: auto;

    .MuiListItemIcon-root {
      background-color: ${props => props.theme.palette.mainAppColor.main};
      min-width: auto;
      border-radius: 50%;
      padding: 13px;
      margin-bottom: 10px;
    }
  }
`;
const CallToActionListItem = (props) => {
    const { onClick, text, activeItem, icon, destination, elementClassName } = props;
    const call = number => {
        document.location.href = `tel:${number}`;
    };
    const email = address => {
        window.location.href = `mailto:?to=${address}`;
    };
    const goToDestination = () => {
        if (destination === 'call' && isMobile()) {
            return call(activeItem.content.phone);
        }
        if (destination === 'email' && isMobile()) {
            return email(activeItem.content.email);
        }
    };
    const renderGraphic = () => {
        if (icon.includes('svg')) {
            return (react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                    __html: icon,
                } }));
        }
        if (icon === 'call') {
            return react_1.default.createElement(LocalPhoneOutlined_1.default, { htmlColor: "black" });
        }
        if (icon === 'room') {
            return react_1.default.createElement(RoomOutlined_1.default, { htmlColor: "black" });
        }
        if (icon === 'email') {
            return react_1.default.createElement(EmailOutlined_1.default, { htmlColor: "black" });
        }
        if (icon === 'calendar_today') {
            return react_1.default.createElement(CalendarMonthOutlined_1.default, { htmlColor: "black" });
        }
        if (icon === 'website') {
            return react_1.default.createElement(LanguageOutlined_1.default, { htmlColor: "black" });
        }
        return null;
    };
    if (destination === 'website') {
        return (react_1.default.createElement(Wrapper, { as: "a", className: elementClassName, href: activeItem.content.website, target: "_blank", rel: "noopener noreferrer" },
            react_1.default.createElement(material_1.ListItemIcon, null, renderGraphic()),
            react_1.default.createElement(material_1.ListItemText, { primary: text })));
    }
    return (react_1.default.createElement(Wrapper, { className: elementClassName, onClick: onClick || goToDestination },
        react_1.default.createElement(material_1.ListItemIcon, null, renderGraphic()),
        react_1.default.createElement(material_1.ListItemText, { primary: text })));
};
const mapStoreToProps = store => ({
    activeItem: store.getValue('activeItem'),
    baseUrl: store.getValue('baseUrl'),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(CallToActionListItem);
